import React, { useContext } from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import PaymentMethodDeleteConfirmModal from '../../payment-wallet/payment-delete-confirm-modal';
import { PaymentProfile } from '../../../__generated__/pge-types';
import {
  useDeleteProfile,
  useSavedProfileList,
} from '../../../hooks/usePaymentus';
import useWrapWithLoader from '../../../hooks/useWrapWithLoading';
import { NotificationsContext } from '../../../providers/NotificationsProvider';
import useAccountCustomer from '../../../hooks/useAccountCustomer';

type Props = {
  open: boolean;
  profile: PaymentProfile;
  onDeleteProfileConfirm: (deleteProfile: PaymentProfile) => void;
  setShowModal: (show: boolean) => void;
};

export default function PaymentProfileRemoveDialog({
  open,
  profile,
  onDeleteProfileConfirm,
  setShowModal,
}: Props) {
  const { customer } = useAccountCustomer();

  const { refetch } = useSavedProfileList(customer);
  const { deleteProfile } = useDeleteProfile();
  const { wrapWithLoader } = useWrapWithLoader();
  const { t } = useTranslation();
  const notificationContext = useContext(NotificationsContext);

  const handleDeleteProfile = wrapWithLoader(async () => {
    if (onDeleteProfileConfirm && profile) {
      await deleteProfile({
        ownerId: customer!.personId,
        token: profile?.token,
      });
      await refetch();
      onDeleteProfileConfirm(profile);
      notificationContext.setState({
        isOpen: true,
        severity: 'success',
        variant: 'filled',
        message: t('PAYMENT_PROFILE_DELETE_SUCCESS_MESSAGE'),
      });
    }
  });

  return (
    <PaymentMethodDeleteConfirmModal
      open={open}
      profile={profile}
      onClose={() => setShowModal(false)}
      onDeleteProfileConfirm={handleDeleteProfile}
    />
  );
}
